import * as React from "react";
import { $, merge } from "glamor";
import theme from "styles/theme";
import { DATATEST } from "constants/integration";
import { MessageBarType, ToastNotification } from "@nuorder/components";
interface IProps {
    open: boolean;
    onClose: () => void;
}

export const ProductGenericToaster: React.FC<IProps> = ({ open, onClose, children }) => {
    const styles = React.useMemo(
        () =>
            merge(
                {
                    position: "absolute",
                    left: "10px",
                    bottom: "10px",
                    zIndex: 500001,
                },
                $(" div.toastContent", {
                    display: "flex",
                    alignItems: "center",
                    padding: "3px 0",
                }),
                $(" .MuiAlert-root", {
                    backgroundColor: "black",
                }),
                $(" .MuiSvgIcon-root, div.toastContent button", {
                    color: theme.palette.accent1Color,
                }),
                $(" .ms-MessageBar-icon i", {
                    fontSize: "1.5em",
                })
            ),
        []
    );

    return (
        open && (
            <div {...styles}>
                <ToastNotification
                    testId={DATATEST.ASSORTMENTS.BOTTOM_LEFT_GENERIC_TOAST}
                    messageBarType={MessageBarType.info}
                    onDismiss={onClose}
                >
                    <div className="toastContent">{children}</div>
                </ToastNotification>
            </div>
        )
    );
};
